import { inject } from '@angular/core';
import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { catchError, throwError } from 'rxjs';
import { AuthService } from '@core/services/auth.service';
import { Router } from '@angular/router';
import { APP_ROUTES } from '@core/constants';

// TODO: Move URLs to centralized config or environment variables
const PUBLIC_ROUTES = ['/api/dispatches/sign/validate', '/api/dispatches/sign/upload'];

/**
 * Authentication interceptor
 *
 * Injects the auth token to all requests if available, and redirects
 * to the home in case of a requests failing with 401.
 */
export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const token = authService.token();

  const isPublicRoute = PUBLIC_ROUTES.some((route) => req.url.includes(route));

  const authReq = token
    ? req.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`,
        },
      })
    : req;

  return next(authReq).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401 && !isPublicRoute) {
        authService.clearToken();
        router.navigate([APP_ROUTES.AUTH.LOGIN.go()]);
      }
      return throwError(() => error);
    }),
  );
};
